import { Common } from '../common';
import {
  ConversionGroupBy,
  ConversionResponse,
  ConversionTotals,
  FeedbackTotals,
  NotificationTotals,
  FilterOptions,
} from '../models/previsit/conversion';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findConversionByPractices(args: {
    start: Date;
    end: Date;
    organizationIds?: string[];
    practiceIds?: string[];
    groupBy?: ConversionGroupBy;
  }): Promise<ConversionResponse<ConversionTotals>> {
    const url = this.common.constructPath(
      `/encounter/previsit-conversion/practices`,
      args,
    );
    return this.common.getJSON(url);
  }

  async findFeedbackTotalsByPractices(args: {
    start: Date;
    end: Date;
    organizationIds?: string[];
    practiceIds?: string[];
    groupBy?: ConversionGroupBy;
  }): Promise<ConversionResponse<FeedbackTotals>> {
    const url = this.common.constructPath(
      `/encounter/previsit-conversion/feedback`,
      args,
    );
    return this.common.getJSON(url);
  }

  async findNotificationTotalsByPractices(args: {
    start: Date;
    end: Date;
    organizationIds?: string[];
    practiceIds?: string[];
    groupBy?: ConversionGroupBy;
  }): Promise<ConversionResponse<NotificationTotals>> {
    const url = this.common.constructPath(
      `/encounter/previsit-conversion/notifications`,
      args,
    );
    return this.common.getJSON(url);
  }

  async getConversionFilterOptions(): Promise<FilterOptions> {
    const url = this.common.constructPath(
      `/encounter/previsit-conversion/filters`,
    );
    return this.common.getJSON(url);
  }
}
